const SkeletonLoader = () => {
  return (
    <div className="c-page-profile">
      <div className="c-page-profile__body">
        <div className="c-profile-body">
          <span className="c-profile__title">Employee Information</span>
          <div
            className="c-profile__item-box-avatar"
            style={{ marginTop: "30px" }}
          >
            <span className="c-profile__item-title">Avatar</span>
            <div className="c-profile__box-avatar">
              <div className="c-profile__avatar">
                <div className="c-view-employee__skeleton-avatar" />
              </div>
            </div>
          </div>
          <div className="c-profile__item-box">
            <div className="c-input">
              <div className="c-input__header">
                <span className="c-input__title">Full Name</span>
              </div>
              <div className="c-view-employee__skeleton-text" />
            </div>
          </div>

          <div className="c-profile__item-box">
            <div className="c-profile__colum">
              <div className="c-input">
                <div className="c-input__header">
                  <span className="c-input__title">E-mail</span>
                </div>
                <div className="c-view-employee__skeleton-text" />
              </div>
            </div>
            <div className="c-profile__colum">
              <div className="c-input">
                <div className="c-input__header">
                  <span className="c-input__title">Alternative E-mail</span>
                </div>
                <div className="c-view-employee__skeleton-text" />
              </div>
            </div>
          </div>

          <div className="c-profile__item-box">
            <div className="c-profile__colum">
              <div className="c-input">
                <div className="c-input__header">
                  <span className="c-input__title">Title</span>
                </div>
                <div className="c-view-employee__skeleton-text" />
              </div>
            </div>
            <div className="c-profile__colum">
              <div className="c-profile__item-box-two">
                <div className="c-profile__colum">
                  <div className="c-input">
                    <div className="c-input__header">
                      <span className="c-input__title">Phone</span>
                    </div>
                    <div
                      className="c-view-employee__skeleton-text"
                      style={{ minWidth: "100px" }}
                    />
                  </div>
                </div>
                <div className="c-input">
                  <div className="c-input__header">
                    <span className="c-input__title">Extension Phone</span>
                  </div>
                  <div
                    className="c-view-employee__skeleton-text"
                    style={{ minWidth: "100px" }}
                  />
                </div>
              </div>
            </div>
          </div>

          <span className="c-profile__subtitle">Location Information</span>

          <div className="c-profile__item-box" style={{ marginTop: "20px" }}>
            <div className="c-profile__colum">
              <div className="c-input">
                <div className="c-input__header">
                  <span className="c-input__title">Street Address</span>
                </div>
                <div className="c-view-employee__skeleton-text" />
              </div>
            </div>
            <div className="c-profile__colum">
              <div className="c-input">
                <div className="c-input__header">
                  <span className="c-input__title">Suite</span>
                </div>
                <div className="c-view-employee__skeleton-text" />
              </div>
            </div>
          </div>

          <div className="c-profile__item-box">
            <div className="c-profile__colum">
              <div className="c-input">
                <div className="c-input__header">
                  <span className="c-input__title">Zip Code</span>
                </div>
                <div className="c-view-employee__skeleton-text" />
              </div>
            </div>
            <div className="c-profile__colum">
              <div className="c-input">
                <div className="c-input__header">
                  <span className="c-input__title">State</span>
                </div>
                <div className="c-view-employee__skeleton-text" />
              </div>
            </div>
          </div>

          <div className="c-profile__item-box">
            <div className="c-profile__colum">
              <div className="c-input">
                <div className="c-input__header">
                  <span className="c-input__title">City</span>
                </div>
                <div className="c-view-employee__skeleton-text" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonLoader;
